(function ($) {
    "use strict";

    var app,
        on_ready,
        on_load,
        $w = $(window),
        $d = $(document),
        $b = $(document.body),
        $header = $(document.getElementById("header")),
        $content = $(document.getElementById("content")),
        $footer = $(document.getElementById("footer"));

    app = {
        vars: {},
        jrespond: (function () {
            var css = $("head").css("font-family").replace(/^"?|"?$|\\/g, "").split(","),
                bps = [],
                bp,
                i;

            for (i = 0; i < css.length; i += 1) {
                bp = css[i].trim().split(' ');
                bps.push({
                    label: bp[0],
                    enter: parseInt(bp[1], 10),
                    exit: parseInt(bp[2], 10)
                });
            }

            return jRespond(bps);
        }()),
        cookie: (function () {
            var set = function (name, value, days) {
                    var expires = days ? '; expires=' + new Date(new Date().getTime() + (days * 24 * 60 * 60 * 1000)).toGMTString() : '';
                    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/' + expires;
                },
                map = function () {
                    var map_cookies = {},
                        cookies = document.cookie.split('; '),
                        cookie,
                        i;

                    for (i = 0; i < cookies.length; i += 1) {
                        cookie = cookies[i].split('=');
                        map_cookies[cookie[0]] = decodeURIComponent(cookie[1]);
                    }
                    return map_cookies;
                },
                get = function (name) {
                    return this.map()[name];
                },
                remove = function (name) {
                    this.set(name, '', -1);
                };

            return {
                set: set,
                map: map,
                get: get,
                remove: remove
            };
        }()),
        debounce: function (fn, threshold) {
            var timeout;

            return function () {
                clearTimeout(timeout);
                var args = arguments;
                var _this = this;
                timeout = setTimeout(function () {
                    fn.apply(_this, args);
                }, threshold || 100);
            };
        },
        bind: function () {
            app.vars.switch = {};

            $d.on("switch_open switch_close switch_toggle", function (e, cls, d) {
                $d.trigger("switch_before." + cls, [e, d]);

                switch (e.type) {
                    case "switch_open":
                        $(d).addClass(cls);
                        break;
                    case "switch_close":
                        $(d).removeClass(cls);
                        break;
                    case "switch_toggle":
                        $(d).toggleClass(cls);
                        break;
                }
                app.vars.switch[d + "_" + cls] = $(d).hasClass(cls);

                $d.trigger("switch_after." + cls, [e, d]);
            });

            $d.on("click.switch", "[data-switch]", function (e) {
                var data = $(e.currentTarget).attr("data-switch").split(',');

                if (!data[2] || data[2] === "this") {
                    data[2] = this;
                }
                $d.trigger("switch_" + data[0], [data[1], data[2]]);
                if (data[3]) {
                    e.preventDefault();
                }
            });

            $d.on("toggler change.toggler", ".js-toggler", function (e) {
                var $toggler = $(e.target),
                    sections = [],
                    selected = $("option:selected", e.target).attr("data-toggler");

                $("option", $toggler).each(function () {
                    if ($(this).data("toggler")) {
                        sections.push("." + $(this).data("toggler"));
                    }
                });
                $(sections.join(",")).each(function () {
                    $(this)[$(this).hasClass(selected) ? "show" : "hide"]();
                });
            });
            $(".js-toggler").trigger("toggler");

            $d.on("click.showmore", ".showmore__btn", function (e) {
                $(this).closest(".showmore").toggleClass("expanded");

                setTimeout(function() {
                    $w.trigger("resize");
                }, 300);
                e.preventDefault();
            });
        },
        form: function () {
            $(".form__item").each(function () {
                if ($(this).hasClass("form__item--select")) {
                    if (!$(".form__arrow", this).length) {
                        $("<span class=\"form__arrow\"></span>").insertAfter($("select", this));
                    }
                }
            });

            $d.on({
                // "mousemove.growing": function (e) {},
                "growing keyup.growing paste.growing blur.growing": function (e) {
                    if (!e || e.which === 8 || e.which === 46 || (e.ctrlKey && e.which === 88)) {
                        $(this).css("height", $(this).data("start-height"));
                    }
                    if ($(this).innerHeight() < this.scrollHeight) {
                        $(this).css("height", this.scrollHeight + 1);
                    }
                }
            }, "textarea.field-growing");

            $("textarea.field-growing").each(function() {
                $(this)
                    .data("start-height", $(this).innerHeight())
                    .trigger("growing");
            });

            $(".floating-label").floatinglabel();
        },
        validator: {
            setup: (function () {
                if (typeof $.fn.validate !== "function") {
                    return;
                }

                $.extend($.validator.messages, {
                    required: translations.form_required,
                    email: translations.form_valid_email,
                    number: translations.form_valid_number,
                    digits: translations.form_valid_digits,
                    max: $.validator.format(translations.form_valid_max),
                    min: $.validator.format(translations.form_valid_min)
                });

                $.validator.setDefaults({
                    invalidHandler: function (e, v) {
                        if (!v.numberOfInvalids()) {
                            return;
                        }
                        app.scrollto($(v.errorList[0].element).closest(".form__item"));
                        $(e.target).addClass("has-error");
                        setTimeout(function () {
                            $(e.target).removeClass("has-error");
                        }, 1000);
                    },
                    focusInvalid: false,
                    wrapper: "span",
                    errorClass: "has-error",
                    validClass: "is-valid",
                    errorPlacement: function (er, el) {
                        var data = el.data("validate");

                        if (data && data.error && $(data.error).length) {
                            er.appendTo($(data.error));
                        } else if (el.attr("type") === "file" || el.attr("type") === "radio" || el.attr("type") === "checkbox" || el.attr("type") === "range") {
                            er.appendTo(el.closest(".form__main").length
                                ? el.closest(".form__main")
                                : el.closest(".form__item"));
                        } else {
                            er.insertAfter(el);
                        }
                        if (er[0].nodeName === "SPAN") {
                            er.addClass("error__wrap");
                        }
                        // return null;
                    },
                    highlight: function (el, ec, vc) {
                        $(el).closest(".form__item").addClass(ec).removeClass(vc);
                    },
                    unhighlight: function (el, ec, vc) {
                        $(el).closest(".form__item").removeClass(ec).addClass(vc);
                    }
                });
            }()),
            validate: function (form) {
                var $form = $(form);

                if (typeof $.fn.validate !== "function") {
                    return;
                }

                $form.field_validate = $("[data-validate]", $form);
                $form.rules = {};
                $form.messages = {};

                if ($form.field_validate.length) {
                    $form.field_validate.each(function () {
                        var el = this,
                            data = $(this).data("validate"),
                            name = $(el).attr("name");

                        if (data.rules) {
                            $form.rules[name] = data.rules;
                        }
                        if (data.messages) {
                            $form.messages[name] = data.messages;
                        }
                    });
                }

                $form.validate({
                    rules: $form.rules,
                    messages: $form.messages
                });

                return $form;
            },
            init: function () {
                $(".js-validator").each(function () {
                    app.validator.validate(this);
                });
            }
        },
        ajax: {
            form: function (form) {
                var $form = $(form);

                if (typeof $.fn.ajaxSubmit !== "function" || ($form.hasClass("js-validator") && !$form.valid())) {
                    return;
                }

                $form.ajaxSubmit({
                    url: drosed.ajaxurl,
                    type: "POST",
                    data: {
                        action: "theme_ajax",
                        token: drosed.token,
                        type: "form"
                    },
                    dataType: "json",
                    resetForm: true,
                    beforeSend: function () {
                        $form.addClass("sending");
                        $("button[type=submit]", $form).addClass("preloader");
                    },
                    success: function (response) {
                        $form.siblings(".alert").remove();
                        if (response.message) {
                            $form.before("<div class=\"alert alert--" + (response.error
                                ? "error"
                                : "success") + "\">" + response.message + "</div>");
                        }

                        if (!response.error) {
                            $form.hide();
                        }

                        $form.removeClass("sending");
                        $("button[type=submit]", $form).removeClass("preloader");
                    }
                });
            },
            init: function () {
                $(".js-ajax-form").on("submit.ajax-form", function (e) {
                    app.ajax.form(this);
                    e.preventDefault();
                });
            }
        },
        scrollto: (function () {
            var $__anchors = $("[data-anchor]"),
                hash = location.hash;

            function scrollto(el) {
                var target,
                    offset,
                    $target;

                if (el.target) {
                    if ($(el.target).data("scrollto") !== undefined) {
                        target = $(el.target).data("scrollto");
                    } else if (el.target.pathname && el.target.hostname && location.pathname.replace(/^\//, "") === el.target.pathname.replace(/^\//, "") && location.hostname === el.target.hostname) {
                        target = el.target.hash;
                    }
                } else {
                    target = el;
                }

                if ($(target).length) {
                    $target = $(target);
                } else if ($("[data-anchor='" + target + "']").length) {
                    $target = $("[data-anchor='" + target + "']");
                }
                if (!target || !$target || !$target.length) {
                    return;
                }

                offset = $target.data("scrollto-offset") !== undefined
                    ? parseInt($target.data("scrollto-offset"), 10)
                    : 0;

                $("body, html").animate({
                    scrollTop: $target.offset().top - parseInt($header.css("min-height"), 10) - 10 - offset
                }, 500);

                return true;
            }

            $d.on("click.scrollto scrollto", "[data-scrollto], a[href*='#']:not([href$='#'])", function (e) {
                if (scrollto(e)) {
                    e.preventDefault();
                }
            });
            $d.on("anchor", "[data-anchor]", function () {
                if ($(this).data("anchor") !== undefined) {
                    scrollto(this);
                }
            });
            $w.on("load", function () {
                if (hash && $__anchors.length) {
                    $__anchors.each(function () {
                        if ($(this).attr("data-anchor") === hash) {
                            $(this).trigger("anchor");
                        }
                    });
                }
            });

            return scrollto;
        }()),
        swiper: function () {
            var $swiper = $(".swiper");

            if (!$swiper.length || typeof Swiper !== "function") {
                return;
            }

            $swiper.each(function (i, el) {
                var swiper = {
                    cont: $(".swiper-container", el)[0],
                    defaults: {
                        // initialSlide: 0,
                        // direction: "horizontal",
                        speed: 1000,
                        // virtualTranslate: false,
                        // autoHeight: false,
                        // roundLengths: false,
                        // nested: false,
                        effect: "fade",
                        fadeEffect: {
                            crossFade: true
                        },
                        // spaceBetween: 0,
                        // slidesPerView: 1,
                        // slidesPerColumn: 1,
                        // slidesPerColumnFill: 'column',
                        // slidesPerGroup: 1,
                        // centeredSlides: false,
                        // slidesOffsetBefore: false,
                        // slidesOffsetAfter: false,
                        // normalizeSlideIndex: true,
                        // grabCursor: true,
                        // touchRatio: 1,
                        // touchAngle: 45,
                        // simulateTouch: true,
                        // shortSwipes: true,
                        // longSwipes: true,
                        // longSwipesRatio: 0.5,
                        // longSwipesMs: 300,
                        // followFinger: true,
                        // allowTouchMove: true,
                        // threshold: 0,
                        // touchMoveStopPropagation: true,
                        // touchReleaseOnEdges: false,
                        // passiveListeners: true,
                        // resistance: true,
                        // resistanceRatio: 0.85,
                        // preventClicks: true,
                        // preventClicksPropagation: true,
                        // slideToClickedSlide: false,
                        // watchSlidesProgress: false,
                        // watchSlidesVisibility: false,
                        loop: true,
                        // loopAdditionalSlides: 0,

                        play: false,
                        hash: false,
                        pager: false,
                        buttons: false,
                        external: false,
                        keyboard: false,
                        blur: false,

                        init: function () {
                            $(el).addClass("swiper-active");
                        }
                    },
                    slides: $(".swiper-slide", el).length,
                    hash: [],
                    filter: ''
                };

                if ($(el).hasClass("swiper-active")) {
                    return;
                }

                function paginationToggle(s) {
                    if (!s.options.pager || !s.options.pagination.el.length) {
                        return;
                    }

                    if ((s.el.params.slidesPerView !== "auto" && s.el.slides.length > s.el.params.slidesPerView) || (s.el.params.slidesPerView === "auto" && s.el.width < s.el.virtualSize)) {
                        s.options.pagination.el.parent().show();
                    } else {
                        s.options.pagination.el.parent().hide();
                    }
                }

                function slideTo(hash) {
                    if (swiper.hash.indexOf(hash) > -1) {
                        swiper.el.slideTo($(".swiper-slide[data-hash='" + hash + "']", el).index());
                    }
                }

                swiper.data = $(swiper.cont).data("swiper-options") || {};
                swiper.options = $.extend(swiper.defaults, swiper.data);

                if (swiper.options.play) {
                    swiper.options.autoplay = {
                        delay: swiper.options.play,
                        // stopOnLast: false,
                        disableOnInteraction: false,
                        pauseOnHover: true
                    };
                }
                if (swiper.options.hash) {
                    swiper.options.hashNavigation = {
                        watchState: true,
                        replaceState: true
                    };
                }
                if (swiper.options.pager) {
                    swiper.options.pagination = {
                        el: $(".swiper-pagination-inner", el),
                        clickable: true
                    };
                    swiper.options.pagination.el.parent()[swiper.slides === 1 ? "hide" : "show"]();
                }
                if (swiper.options.buttons) {
                    swiper.options.navigation = {
                        prevEl: $(".swiper-button-prev", el)[0],
                        nextEl: $(".swiper-button-next", el)[0]
                    };
                    $(".swiper-buttons", el).show();
                }

                $(".swiper-wrapper", el).children().addClass("swiper-slide");

                swiper.el = new Swiper(swiper.cont, swiper.options);

                if (swiper.options.play && swiper.options.autoplay.delay && swiper.options.autoplay.delay > 0 && swiper.options.autoplay.pauseOnHover) {
                    $(swiper.cont).on("mouseenter.swiper", swiper.el.autoplayStop).on("mouseleave.swiper", swiper.el.stopAutoplay);
                }

                $w.on("resize.swiper-resize", function () {
                    paginationToggle(swiper);
                });

                if (swiper.options.external && $(swiper.options.external).length) {
                    $(".swiper-slide", el).map(function () {
                        if ($(this).attr("data-hash") !== undefined) {
                            swiper.hash.push($(this).attr("data-hash"));
                        }
                    });
                    swiper.el.on("transitionStart", function () {
                        $("a[href^='#" + $(".swiper-slide", el).eq(swiper.el.activeIndex).attr("data-hash") + "']", swiper.options.external).parent("li").addClass("active").siblings("li").removeClass("active");
                    });
                    $(".swiper-slide", el).on("onScrollTo", function () {
                        slideTo($(this).attr("data-hash"));
                    });
                    if (location.hash && $("a[href='" + location.hash + "']", swiper.options.external).length) {
                        slideTo(location.hash.slice(1));
                    }
                    // $("a", $(swiper.options.external)).on("click", function (e) {
                    //     slideTo(this.hash.slice(1));
                    // });
                    $w.on("hashchange", function () {
                        slideTo(location.hash.slice(1));
                    });
                }

                $(swiper.cont).on("update", function () {
                    swiper.el.onResize();
                    swiper.el.slideTo(0, 0);
                });
            })
                .each(function (i, el) {
                    var swiper = $('.swiper-container', el)[0].swiper;

                    if (swiper.params.sync && $(swiper.params.sync).length && $('.swiper-container', swiper.params.sync)[0].swiper) {
                        swiper.controller.control = $('.swiper-container', swiper.params.sync)[0].swiper;
                    }
                });
        },
        // gmap: function () {
        //     var $gmap = $("[data-gmap]");
        //
        //     if (!$gmap.length || typeof google.maps !== "object") {
        //         return;
        //     }
        //     $gmap.each(function () {
        //         $(this).gmap();
        //     });
        // },
        popup: function () {
            var $gallery = $(".gallery", $content),
                $data_gallery = $("[data-gallery]", $content),
                galleries = {};

            function change_image_size() {
                var mfp_img = $(".mfp-img", this.content),
                    mfp_figure = $(this.content);

                mfp_img.css("max-height", $w.height() - parseInt(mfp_figure.css('padding-top'), 10) - parseInt(mfp_figure.css('padding-bottom'), 10));
            }

            if (typeof $.magnificPopup !== "object") {
                return;
            }

            $.extend(true, $.magnificPopup.defaults, {
                tClose: translations.close,
                closeMarkup: '<button type="button" title="%title%" class="mfp-close btn__close">&#215;</button>',
                tLoading: translations.loading,
                gallery: {
                    tPrev: translations.previous,
                    tNext: translations.next,
                    tCounter: "%curr% " + translations.of + " %total%",
                    arrowMarkup: '<button type="button" title="%title%" class="mfp-arrow mfp-arrow-%dir% btn__%dir%"></button>'
                },
                image: {
                    tError: "<a href=\"%url%\">" + translations.the_image + "</a> " + translations.could_not_be_loaded + "."
                },
                ajax: {
                    tError: "<a href=\"%url%\">" + translations.the_content + "</a> " + translations.could_not_be_loaded + "."
                }
            });

            $(".popup:not(.popup--youtube):not(.popup--inline):not(.popup--iframe)").magnificPopup({
                type: "image",
                closeBtnInside: true,
                callbacks: {
                    resize: change_image_size,
                    imageLoadComplete: change_image_size,
                    change: change_image_size
                }
            });
            $(".popup.popup--youtube").magnificPopup({
                type: "iframe",
                closeBtnInside: true
            });
            $(".popup.popup--iframe").magnificPopup({
                type: "iframe",
                closeBtnInside: true,
                fixedContentPos: false
            });
            $(".popup.popup--inline").magnificPopup({
                mainClass: 'mfp-no-margins',
                // closeBtnInside: false,
                // removalDelay: 500,
                callbacks: {
                    beforeOpen: function() {
                        this.st.mainClass = 'mfp-zoom-in';
                    }
                }
            });

            if ($gallery.length) {
                $gallery.each(function (index) {
                    $(".gallery-item a", this).each(function (i, el) {
                        if (!$(el).attr("data-gallery")) {
                            $(el).attr("data-gallery", index);
                        }
                    });
                    if (this.className.indexOf("gallery-columns") > -1) {
                        $(".gallery-item a", this).addClass("img-anim img-anim-main");
                    }
                });
            }
            if ($data_gallery.length) {
                $data_gallery.each(function (i, el) {
                    var id = $(this).data("gallery"),
                        img = $("img", el),
                        alt;

                    if (img.length && img.attr("alt") !== "") {
                        alt = new RegExp(img.attr("alt").toLowerCase().replace("_", "-"));

                        if (!alt.test(img.attr("src"))) {
                            $(el).attr("title", img.attr("alt"));
                        }
                    }

                    if (!galleries[id]) {
                        galleries[id] = [];
                    }
                    galleries[id].push(el);
                });

                $.each(galleries, function (i, el) {
                    $(el).magnificPopup({
                        type: "image",
                        closeOnContentClick: false,
                        closeBtnInside: true,
                        gallery: {
                            enabled: true
                        },
                        image: {
                            titleSrc: "title"
                        },
                        callbacks: {
                            resize: change_image_size,
                            imageLoadComplete: change_image_size,
                            change: change_image_size
                        }
                    });
                });
            }
        },
        header: function () {
            var header_shadow_offset = parseInt($header.css("min-height"), 10),
                $nav_head = $("#nav_head", $header),
                $nav_lang = $("#nav_lang", $header),
                $navmobile,
                $nav_mobile;

            $w.on("scroll.head--shadow", function () {
                var st = $w.scrollTop();

                if (st >= header_shadow_offset && !app.vars.header_shadow) {
                    $header.addClass("head--shadow");
                    app.vars.header_shadow = true;
                } else if (st < header_shadow_offset && app.vars.header_shadow) {
                    $header.removeClass("head--shadow");
                    app.vars.header_shadow = false;
                }
            });

            var menu_st,
                menu_vars = app.vars.switch;

            $d.on("switch_after.open--menu", function() {
                $header.css("transform", "");

                if (menu_vars["body_open--menu"]) {
                    menu_st = $w.scrollTop();
                } else {
                    $("body, html").animate({
                        scrollTop: menu_st
                    }, 0);
                }
            });

            $navmobile = $("<div>", {
                class: "head__navmobile navmobile",
                html: $("<div>", {
                    class: "navmobile__wrap wrapper"
                })
            }).appendTo($header);

            $("<nav>", {
                id: "nav_langmobile",
                class: "nav--lang nav--langmobile",
                html: $nav_lang.clone().html()
            }).appendTo($(".navmobile__wrap", $navmobile));

            $nav_mobile = $("<nav>", {
                id: "nav_mobile",
                class: "nav--mobile",
                html: $nav_head.clone().html()
            }).appendTo($(".navmobile__wrap", $navmobile));

            $nav_mobile.data("current", $("li.current-menu-item", $nav_mobile));
            $nav_mobile.data("products", $("li.products", $nav_mobile));
            $("a, li, ul", $nav_mobile).removeAttr("id class style");
            if ($nav_mobile.data("current").length) {
                $nav_mobile.data("current").addClass("mm-selected");
            }
            if ($nav_mobile.data("products").length) {
                $nav_mobile.data("products").addClass("mm-fullsubopen");
            }

            $nav_mobile.mmenu({
                extensions: ["fullscreen"],
                offCanvas: false,
                autoHeight: {
                    height: "auto"
                },
                navbar: {
                    add: true,
                    title: "",
                    titleLink: "parent"
                }
                // counters: true
            });

            $(".products > a", $nav_head).on("click", function (e) {
                e.preventDefault();
            });

            app.jrespond.addFunc({
                breakpoint: ["xs", "sm", "md"],
                enter: function () {
                    $header.scrollupbar();
                },
                exit: function () {
                    $.scrollupbar.destroy();
                    $header.removeAttr("style");
                    $d.trigger("switch_close", ["open--menu", "body"]);
                }
            });
        },
        content: function () {
            (function () {
                var $homerow = $(".homerow", $content),
                    $homerow_left = $(".homerow__left", $homerow);

                if (!$homerow.length) {
                    return;
                }

                function set_size_goodnews_ribbon () {
                    $(".goodnews-ribbon__wrap", $homerow).css("width", $homerow_left.offset().left + $homerow_left.width());
                }
                app.jrespond.addFunc({
                    breakpoint: ["lg", "xl"],
                    enter: function () {
                        $w.on("resize.goodnews-ribbon", set_size_goodnews_ribbon).trigger("resize.goodnews-ribbon");
                    },
                    exit: function () {
                        $w.off("resize.goodnews-ribbon");
                        $(".goodnews-ribbon__wrap", $homerow).removeAttr("style");
                    }
                });
            }());

            (function () {
                var $headline_row = $("[data-headline-row]");

                if (!$headline_row.length) {
                    return;
                }

                $w.on("resize", function () {
                    $headline_row.each(function () {
                        var $row = $(":first-child", this),
                            height_row;

                        $row.addClass("onerow");
                        height_row = $row.height();
                        $row.removeClass("onerow");

                        $(this).attr("data-headline-row", Math.round($row.height() / height_row));
                    });
                });
            }());

            (function () {
                var $goodtoknow = $(".goodtoknow__page", $content),
                    selectors = {};

                if (!$goodtoknow.length) {
                    return;
                }

                if ($goodtoknow.hasClass("goodtoknow__page--fitimg")) {
                    app.jrespond.addFunc({
                        breakpoint: ["lg", "xl"],
                        enter: function () {
                            $w.on("resize.goodtoknow_page_fitimg goodtoknow_page_fitimg", function () {
                                $(".goodtoknow__main", $goodtoknow).css("min-height", $w.height() - parseInt($content.css("padding-top"), 10) - parseInt($content.css("padding-bottom"), 10) - parseInt($goodtoknow.css("padding-top"), 10) - $footer.height());
                            }).trigger("goodtoknow_page_fitimg");
                        },
                        exit: function () {
                            $w.off("resize.goodtoknow_page_fitimg");
                            $(".goodtoknow__main", $goodtoknow).css("min-height", "");
                        }
                    });
                }
                if ($goodtoknow.hasClass("goodtoknow__layout--3")) {
                    // selectors.imgage_3 = $(".goodtoknow__image", $goodtoknow_layout_3);
                    // selectors.img_3 = $("img", $goodtoknow_layout_3);
                    // selectors.embellishment_image = $(".foot__embellishment--image", $footer);
                    //
                    // app.jrespond.addFunc({
                    //     breakpoint: ["lg", "xl"],
                    //     enter: function () {
                    //         $w.on("resize.goodtoknow_layout_3 goodtoknow_layout_3", function () {
                    //             var max_height = $footer.offset().top - parseInt($content.css("padding-top"), 10) - parseInt($goodtoknow_layout_3.css("padding-top"), 10);
                    //             selectors.imgage_3.css("height", max_height);
                    //             selectors.embellishment_image.css("height", max_height);
                    //             if (selectors.img_3.height() < $w.height() - parseInt($content.css("padding-top"), 10) - parseInt($goodtoknow_layout_3.css("padding-top"), 10) - $footer.height()) {
                    //                 selectors.img_3.css("opacity", 0);
                    //                 selectors.embellishment_image.show();
                    //             } else {
                    //                 selectors.img_3.css("opacity", 1);
                    //                 selectors.embellishment_image.hide();
                    //             }
                    //         }).trigger("goodtoknow_layout_3");
                    //     },
                    //     exit: function () {
                    //         $w.off("resize.goodtoknow_layout_3");
                    //         selectors.imgage_3.css("height", "");
                    //         selectors.img_3.css("opacity", "");
                    //         selectors.embellishment_image.hide();
                    //     }
                    // });
                }
            }());

            // (function () {
            //     var $goodtoknow_page_fitimg = $(".goodtoknow__page--fitimg", $content);
            //
            //     if ($goodtoknow_page_fitimg.length) {
            //         app.jrespond.addFunc({
            //             breakpoint: ["lg", "xl"],
            //             enter: function () {
            //                 $w.on("resize.goodtoknow_page_fitimg goodtoknow_page_fitimg", function () {
            //                     $(".goodtoknow__main", $goodtoknow_page_fitimg).css("min-height", $w.height() - parseInt($content.css("padding-top"), 10) - parseInt($content.css("padding-bottom"), 10) - parseInt($goodtoknow_page_fitimg.css("padding-top"), 10) - $footer.height());
            //                 }).trigger("goodtoknow_page_fitimg");
            //             },
            //             exit: function () {
            //                 $w.off("resize.goodtoknow_page_fitimg goodtoknow_page_fitimg");
            //                 $(".goodtoknow__main", $goodtoknow_page_fitimg).css("min-height", "");
            //             }
            //         });
            //     }
            // }());

            (function () {
                var $advices_page_fitimg = $(".advices__page--fitimg", $content);

                if ($advices_page_fitimg.length) {
                    app.jrespond.addFunc({
                        breakpoint: ["lg", "xl"],
                        enter: function () {
                            $w.on("resize.advices_page_fitimg advices_page_fitimg", function () {
                                $(".advices__main", $advices_page_fitimg).css("min-height", $w.height() - parseInt($content.css("padding-top"), 10) - parseInt($advices_page_fitimg.css("padding-top"), 10));
                            }).trigger("advices_page_fitimg");
                        },
                        exit: function () {
                            $w.off("resize.advices_page_fitimg advices_page_fitimg");
                            $(".advices__main", $advices_page_fitimg).css("min-height", "");
                        }
                    });
                }
            }());

            (function () {
                var $calculator_scale = $("#calculator_scale", $content),
                    $calculator_product,
                    $calculator_glass,
                    $calculator_spoon,
                    $calculator_teaspoon;

                if (!$calculator_scale.length) {
                    return;
                }

                $calculator_product = $("#calculator_product", $calculator_scale);
                $calculator_glass = $("#calculator_glass", $calculator_scale);
                $calculator_spoon = $("#calculator_spoon", $calculator_scale);
                $calculator_teaspoon = $("#calculator_teaspoon", $calculator_scale);

                $calculator_product.on("change", function (e) {
                    var value = this.value.split('|'), values = new Array(3);

                    if (Array.isArray(value) && value.length === 3) {
                        values = [value[0], value[1], value[2]];
                    }

                    $calculator_glass.val(values[0]);
                    $calculator_spoon.val(values[1]);
                    $calculator_teaspoon.val(values[2]);

                    e.preventDefault();
                });
            }());
        },
        footer: function () {
            function footer_sticky () {
                $footer[$w.height() > $content.outerHeight() + $footer.outerHeight() ? "addClass" : "removeClass"]("foot--sticky");
            }

            app.jrespond.addFunc({
                breakpoint: ["md", "lg", "xl"],
                enter: function () {
                    $w.on("resize.foot--sticky load", footer_sticky).trigger("resize.foot--sticky");
                },
                exit: function () {
                    $w.off("resize.foot--sticky");
                    $footer.removeClass("foot--sticky");
                }
            });
        },
        cookiealert: function () {
            var $cookie_alert;

            if (!app.cookie.get("cookie-alert")) {
                $cookie_alert = $("<div>", {
                    id: "cookie_alert",
                    class: "cookie__alert",
                    html: "<div class=\"wrapper\"><p>" + translations.cookies_policy_text + " <button id=\"cookie_close\" class=\"cookie__close\" title=\"" + translations.cookies_policy_btn + "\">" + translations.cookies_policy_btn + "</button></p></div>"
                }).appendTo($b);

                $d.trigger("cookie_alert");

                $("#cookie_close", $cookie_alert).on("click", function (e) {
                    app.cookie.set("cookie-alert", 1, 365);
                    $cookie_alert.addClass("is-hidden");
                    setTimeout(function () {
                        $d.trigger("cookie_alert");
                    }, parseFloat($cookie_alert.css("transition-duration")) * 1000);

                    e.preventDefault();
                });
            }
        }
    };

    on_ready = function () {
        app.bind();
        app.form();
        app.validator.init();
        app.ajax.init();
        app.swiper();
        app.popup();
        app.header();
        app.content();
        app.footer();
        app.cookiealert();

        $w.resize().scroll();
    };
    on_load = function () {
        window.loaded = true;
    };

    window.app = $.extend({}, window.app, {
        vars: app.vars,
        jrespond: app.jrespond,
        cookie: app.cookie,
        debounce: app.debounce,
        form: app.form,
        validate: app.validator.validate,
        ajax: {
            form: app.ajax.form
        },
        scrollto: app.scrollto
    });

    $(on_ready);
    $w.on("load", on_load);

}(jQuery));